import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "@/i18n/lang";

// GLOBAL STYLES
import "@/styles/global.scss";

//GLOBAL FILTER
import "@/assets/js/filters/globalFilter.js";

//  GLOBAL COMPONENTS
import "@/assets/js/globalComponents";

//  ANIME JS
import anime from "animejs";

//  VUE PERFECT SCROLLBAR
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);

// TOUCH EVENTS
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

import vClickOutside from "v-click-outside";

Vue.use(vClickOutside);

//  VUE CALENDAR
import VCalendar from "v-calendar";
// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

//  VUE TOOLTIP
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// Moment js for date formating
import Moment from "moment";
import "moment/locale/hu";

//  Vue qr code reader
import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);

/*
 * EventBus for global event handling
 */
import EventBus from "@/eventbus";
/*
 * Show notificaiton for global notification
 */
import showNotification from "@/assets/js/showNotification";
/*
 * Variables for storing global data
 */

import Variables from "@/assets/js/variables";

Vue.prototype.$variables = Variables;
Vue.prototype.$notification = showNotification;
Vue.prototype.$anime = anime;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$moment = Moment;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
